/**
 * Day/night classification of a Route. The dispatch wizard uses
 * this to filter route candidates against each client's
 * `nightTimeEligibility`:
 *
 * - DAY:    a DAY_ONLY or EITHER client may be on this route
 * - NIGHT:  a NIGHT_ONLY or EITHER client may be on this route
 * - EITHER: any client may be on this route (no time restriction)
 *
 * Companion to {@link ClientNightTimeEligibilityEnum} —
 * see `client-night-time-eligibility.ts`. The compatibility matrix
 * (Phase C Rule 3) is in `DispatchService._nightTimeIncompatibilityReason`.
 *
 * Defaults to DAY so existing routes stay valid for the DAY_ONLY
 * default on `Client.nightTimeEligibility`.
 */
export enum RouteTimeClassificationEnum {
	DAY = 'DAY',
	NIGHT = 'NIGHT',
	EITHER = 'EITHER',
}
